* {
  margin: 0pt;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
}

button {
  width: 100%;
  height: 100%;
  color: $xp-ref-color-semantic-interaction;
  fill: $xp-ref-color-semantic-interaction;
  border: 2.5pt solid $xp-ref-color-semantic-interaction;
  border-radius: $xp-ref-border-radius-1;
  font: $xp-ref-font-label-label-short;
  padding: 7pt;
  background-color: transparent;
  cursor: pointer;
  flex: 1;
  gap: 0;
  text-align: center;

  overflow-wrap: anywhere;
  /* layout */
  display: flex;
  flex-direction: row;
  align-items: center;

  /* animations */
  transition: all;
  transition-duration: 150ms;
  justify-content: center;
}

button:hover {
  background-color: $xp-ref-color-semantic-interaction;
  color: white;
  fill: white;
}

button:active {
  opacity: 0.9;
}

button:disabled {
  color: $xp-ref-color-state-on-disabled;
  background-color: $xp-ref-color-state-disabled;
  border: 2.5pt solid $xp-ref-color-state-disabled;
}

.filled {
  background-color: $xp-ref-color-semantic-interaction;
  color: white;
  fill: white;
}

.filled:hover {
  opacity: 0.9;
}

.filled:active {
  opacity: 0.8;
}

.borderless {
  border: none;
}

.text-placeholder {
  visibility: hidden;
  height: 0px;
}

.error {
  &:hover {
    background-color: $xp-ref-color-semantic-on-critical;
    border-color: $xp-ref-color-semantic-on-critical;
  }
  color: white;
  border-color: $xp-ref-color-semantic-critical-definite;
  background-color: $xp-ref-color-semantic-critical-definite;
}
